import React, { useEffect, useState } from "react";
import PageTitle from '../components/PageTitle';
import Services from "../components/individual/Services.js";
import ITServices from "../components/individual/ITServices.js";
import Client from "../components/individual/Client.js";
import Homehero from "../components/individual/Home/Homehero.js";
import ITServicesComponent from "../components/individual/Home/ITServicesComponent.js";
import Stats from "../components/individual/Home/Stats.js";
import CampaignBanner from "../components/individual/Home/Campaignbanner.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const [, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // OK to keep empty array here; setWindowWidth is stable

  return (
    <>
      {/* Campaign banner #1 — right under the navbar, no top gap */}
      <div style={{ padding: "0 0 24px" }}>
        <CampaignBanner />
      </div>

      <PageTitle 
        title="24時間365日のIT運用・監視サービス" 
        description="DG FutureTech India Private Limited - Leading provider of managed IT services, security solutions, and technology consulting for businesses."
      />
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <Homehero />
        </div>

        <div>
          <ITServices />
        </div>

        {/* Campaign banner #2 — compact repeat */}
        <div style={{ padding: "16px 0" }}>
          <CampaignBanner />
        </div>

        <div>
          <Services />
          <Stats />
        </div>

        <div>
          <Client />
        </div>

        {/* Campaign banner #3 — compact repeat */}
        <div style={{ padding: "16px 0" }}>
          <CampaignBanner />
        </div>

        <div>
          <ITServicesComponent />
        </div>

      </div>
    </>
  );
};

export default Home;